<template>
    <!-- Decorativo: quem usa o tile põe o nome ao lado, o tile só acelera o reconhecimento. -->
    <span class="brand-tile"
        :class="{'is-text': !image && !icon, 'is-muted': muted}"
        :style="tileStyle"
        aria-hidden="true">
        <img v-if="image" :src="image" alt="" />
        <fa v-else-if="icon" :icon="icon" />
        <template v-else>{{text}}</template>
    </span>
</template>

<script>
/**
 * Quadrado de identidade (estilo ícone de app) usado para canais, retaguarda e
 * Muven. Todos no mesmo recipiente: é o que mantém colunas alinhadas mesmo com
 * marcas de formatos e cores tão diferentes.
 *
 * Prioridade do conteúdo: image > icon > text (monograma).
 */
export default {
    name: 'BrandTileCmp',
    props: {
        size: {
            type: Number,
            default: 22,
        },
        image: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: '',
        },
        // Cor de marca (literal) ou token de tema (`var(--...)`)
        background: {
            type: String,
            default: 'var(--white)',
        },
        color: {
            type: String,
            default: 'var(--white)',
        },
        // Opção desaconselhada: o tile perde força para não competir com as demais.
        muted: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        tileStyle() {
            const style = {
                width: `${this.size}px`,
                height: `${this.size}px`,
                // Raio proporcional: 5px no tamanho da grid, sem virar quadrado duro nos maiores.
                borderRadius: `${Math.round(this.size * .23)}px`,
                // Ícone precisa de mais corpo que as letras do monograma.
                fontSize: `${Math.round(this.size * (this.icon && !this.image ? .5 : .4))}px`,
            }

            // Com imagem o tile usa o fundo do tema (--brand-tile-bg): o ícone da marca já traz o próprio fundo ou assenta nele.
            if (!this.image) {
                style.backgroundColor = this.background
                style.color = this.color
            }

            return style
        },
    },
}
</script>

<style lang="scss" scoped>
.brand-tile {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    // Branco no claro, escuro no escuro: o logo com fundo transparente acompanha o tema
    background-color: var(--brand-tile-bg);
    line-height: 1;
    transition: opacity .15s ease-in-out;

    // Hairline por cima da imagem: separa as marcas de fundo branco do zebrado
    // sem somar pixels ao tile. No ::after porque a img cobriria uma sombra do
    // próprio tile.
    &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: inherit;
        box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--text-strong) 10%, transparent);
        pointer-events: none;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &.is-text {
        font-weight: 700;
        letter-spacing: .3px;
    }

    &.is-muted {
        opacity: .45;
    }
}
</style>
